module.exports = __webpack_public_path__ + "img/home-01.54c5a822.svg";